import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#229EEC',
      contrastText: '#FFF'
    }
  },
  sideBar: {
    active: 'yellow',
    hoverBackground: '#128EDC'
  }
})

export {
  theme
}
